function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { defineElements } from '@lumieducation/h5p-webcomponents';
defineElements('h5p-player');

var H5PPlayerUI = /*#__PURE__*/function (_React$Component) {
  _inherits(H5PPlayerUI, _React$Component);

  var _super = _createSuper(H5PPlayerUI);

  function H5PPlayerUI(props) {
    var _this;

    _classCallCheck(this, H5PPlayerUI);

    _this = _super.call(this, props);

    _this.loadContentCallbackWrapper = function (contentId) {
      return _this.props.loadContentCallback(contentId);
    };

    _this.onInitialized = function (event) {
      if (_this.props.onInitialized) {
        _this.props.onInitialized(event.detail.contentId);
      }
    };

    _this.onxAPIStatement = function (event) {
      if (_this.props.onxAPIStatement) {
        _this.props.onxAPIStatement(event.detail.statement, event.detail.context, event.detail.event);
      }
    };

    _this.h5pPlayer = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(H5PPlayerUI, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerEvents();
      this.setServiceCallbacks();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.registerEvents();
      this.setServiceCallbacks();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unregisterEvents();
    }
    /**
     * The internal H5P instance object of the H5P content.
     *
     * Only available after the `initialized` event was fired. Important: This
     * object is only partially typed and there are more properties and methods
     * on it!
     */

  }, {
    key: "h5pInstance",
    get: function get() {
      var _a;

      return (_a = this.h5pPlayer.current) === null || _a === void 0 ? void 0 : _a.h5pInstance;
    }
    /**
     * The global H5P object / namespace (normally accessible through "H5P..."
     * or "window.H5P") of the content type. Depending on the embed type this
     * can be an object from the internal iframe, so you can use it to break the
     * barrier of the iframe and execute JavaScript inside the iframe.
     *
     * Only available after the `initialized` event was fired. Important: This
     * object is only partially typed and there are more properties and methods
     * on it!
     */

  }, {
    key: "h5pObject",
    get: function get() {
      var _a;

      return (_a = this.h5pPlayer.current) === null || _a === void 0 ? void 0 : _a.h5pObject;
    }
    /**
     * Returns the copyright notice in HTML that you can insert somewhere to
     * display it. Undefined if there is no copyright information.
     */

  }, {
    key: "getCopyrightHtml",
    value: function getCopyrightHtml() {
      var _a, _b;

      return (_b = (_a = this.h5pPlayer.current) === null || _a === void 0 ? void 0 : _a.getCopyrightHtml()) !== null && _b !== void 0 ? _b : '';
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      // Should the old editor instance be destroyed, we unregister from it...
      this.unregisterEvents();
      return null;
    }
    /**
     * @returns true if there is copyright information to be displayed.
     */

  }, {
    key: "hasCopyrightInformation",
    value: function hasCopyrightInformation() {
      var _a;

      return (_a = this.h5pPlayer.current) === null || _a === void 0 ? void 0 : _a.hasCopyrightInformation();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("h5p-player", {
        ref: this.h5pPlayer,
        "content-id": this.props.contentId
      });
    }
    /**
     * Displays the copyright notice in the regular H5P way.
     */

  }, {
    key: "showCopyright",
    value: function showCopyright() {
      var _a;

      (_a = this.h5pPlayer.current) === null || _a === void 0 ? void 0 : _a.showCopyright();
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var _a, _b;

      (_a = this.h5pPlayer.current) === null || _a === void 0 ? void 0 : _a.addEventListener('initialized', this.onInitialized);

      if (this.props.onxAPIStatement) {
        (_b = this.h5pPlayer.current) === null || _b === void 0 ? void 0 : _b.addEventListener('xAPI', this.onxAPIStatement);
      }
    }
  }, {
    key: "setServiceCallbacks",
    value: function setServiceCallbacks() {
      if (this.h5pPlayer.current) {
        this.h5pPlayer.current.loadContentCallback = this.loadContentCallbackWrapper;
      }
    }
  }, {
    key: "unregisterEvents",
    value: function unregisterEvents() {
      var _a, _b;

      (_a = this.h5pPlayer.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('initialized', this.onInitialized);

      if (this.props.onxAPIStatement) {
        (_b = this.h5pPlayer.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('xAPI', this.onxAPIStatement);
      }
    }
  }]);

  return H5PPlayerUI;
}(React.Component);

export { H5PPlayerUI as default };